module.exports = __webpack_public_path__ + "assets/img/36_1503_big.28fd0f7f.jpg";